import StickyToolbar from "../../../../Components/StickyToolbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import StorageManagerCapys from "../../../../Tools/Storage";

export interface IRelatoriosFilterProps {
    handleSubmit: (filter: RelatoriosFilterType) => void;
    defaultFilter?: RelatoriosFilterType;
    storageManager: StorageManagerCapys<RelatoriosFilterType>;
}

type RelatoriosFilterType = {
    DT_FILTRO_INICIO: string;
    DT_FILTRO_FINAL: string;
};

export default function RelatoriosFilter(props: IRelatoriosFilterProps) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;

    const FormMethods = useForm();
    const { reset } = FormMethods;

    return (
        <StickyToolbar active={Boolean(filter)}>
            <FormProvider {...FormMethods}>
                <UnForm
                    usingContext
                    handleSubmit={hadleFilterFormSubmit}
                    className="row no-gutters"
                >
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_FILTRO_INICIO}
                            name="DT_FILTRO_INICIO"
                            label="Data Inicio"
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_FILTRO_FINAL}
                            name="DT_FILTRO_FINAL"
                            label="Data Final"
                        />
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                reset({
                                    DT_FILTRO_FINAL: "",
                                    DT_FILTRO_INICIO: "",
                                });
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
